/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import { preferredLanguage, savePreferredLanguage } from "../utils/appLanguage";
import { THEME_STORAGE_KEY } from "../utils/appearancePreference";

export function joinAppearance() {
  const preference = preferredLanguage();
  return {
    language: preference === "ru" || preference === "en" ? preference : "",
    theme:
      document.body.classList.contains("cpd-theme-light") ||
      document.body.classList.contains("cpd-theme-light-hc")
        ? "light"
        : "dark",
  };
}

/** Only call after the bridge has checked both the sender origin and window. */
export function applyJoinAppearance(value: unknown): void {
  if (
    !value ||
    typeof value !== "object" ||
    !("language" in value) ||
    !("theme" in value)
  )
    return;
  if (
    !["", "ru", "en"].includes(value.language as string) ||
    !["light", "dark"].includes(value.theme as string)
  )
    return;
  try {
    savePreferredLanguage(value.language as string);
    localStorage.setItem(THEME_STORAGE_KEY, value.theme as string);
  } catch {
    /* A preference storage failure must not block joining the call. */
  }
}
